export default __webpack_public_path__ + "static/media/logo_q.8d1646cb.png";